import {
  Button,
  CardContainer,
  Colorway,
  H3,
  P,
  Strong,
} from '@driftt/tide-core'
import {
  ModalBody,
  ModalFooter,
  ModalTitle,
  useCloseModal,
} from '@driftt/tide-modal'
import classnames from 'classnames'
import React, { useState } from 'react'

import { isEmptyOrNil } from 'utils'

import Badge from './Badge'
import VersionHistory from './VersionHistory'

const Method = {
  Edit: 'edit',
  End: 'end',
}

const MethodSelection = ({
  onNextStepClick,
  onEditExperiment,
  timeSinceLastPublish,
  isLoading,
}) => {
  const handleCloseModal = useCloseModal()
  const [selectedMethod, setSelectedMethod] = useState()

  const handleContinueClick = () => {
    switch (selectedMethod) {
      case Method.Edit:
        onEditExperiment()
        handleCloseModal()
        break
      case Method.End:
        onNextStepClick()
        break
      default:
    }
  }

  const continueButtonText =
    selectedMethod === Method.Edit ? 'End test' : 'Choose winner'

  return (
    <>
      <ModalTitle>
        It's time to choose a winner and end your A/B test!
      </ModalTitle>
      <ModalBody>
        <P className="end-experiment-modal-copy">
          This A/B test has been running for{' '}
          <Strong>{timeSinceLastPublish}</Strong>
        </P>
        <div className="end-experiment-modal-method-select-container">
          {[
            {
              Icon: Badge,
              label: 'Choose winner',
              method: Method.End,
            },
            {
              Icon: VersionHistory,
              label: 'Edit and restart',
              colorwayType: 2,
              method: Method.Edit,
            },
          ].map((option) => (
            <CardContainer
              key={option.label}
              className={classnames(
                'end-experiment-modal-method-select',
                option.method === selectedMethod &&
                  'end-experiment-modal-method-select--selected'
              )}
              onClick={() => setSelectedMethod(option.method)}
            >
              <Colorway size="small" type={option.colorwayType}>
                <option.Icon />
              </Colorway>
              <H3 className="end-experiment-modal-method-select-title">
                {option.label}
              </H3>
            </CardContainer>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={handleContinueClick}
          disabled={isEmptyOrNil(selectedMethod)}
          loading={isLoading}
        >
          {continueButtonText}
        </Button>
        <Button
          onClick={handleCloseModal}
          style={{ marginLeft: 8 }}
          type="tertiary"
        >
          Cancel
        </Button>
      </ModalFooter>
    </>
  )
}

export default MethodSelection
